import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { VivaSelectComponent } from './viva-select.component';

@NgModule({
  declarations: [
    VivaSelectComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    VivaSelectComponent
  ]
})
export class  VivaSelectModule { }
